import React from 'react';
import Hero from './Hero';
import NavbarStandard from './NavbarStandard';
import Partners from './Partners';
import Processes from './Processes';
import Services from './Services';
import Testimonial from './Testimonial';
import Cta from './Cta';
import Faq from '../../documentation/Faq';
import FooterStandard from './FooterStandard';
import Security from './Security';

const Landing = () => {

  return (
    <>
      <NavbarStandard />
      <Hero />
      <Partners />
      <Processes />
      <Services />
      <Security />
      <Testimonial />
      <Faq />
      <Cta />
      <FooterStandard />
    </>
  );
};

export default Landing;
